<template>
  <request-form @close="onClose" />
</template>
<script>
import RequestForm from './ImagePoliciesForm.vue'

export default {
  name: 'RequestPolicyCreate',
  components: { RequestForm },
  created() {
    this.$store.commit('imagePolicies/SET_IMAGEPOLICY', {
      name: '',
      comment: '',
      processingOptions: {
        width: 0,
        height: 0,
        resize: '',
        gravity: '',
        enlarge: false,
        blur: 0,
        sharpen: 0,
        quality: 0,
        format: '',
      },
    })
  },
  methods: {
    onClose() {
      this.$router.push({ name: 'image-policies' })
    },
  },
}
</script>
